import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Kacper Gunia is an independent Software Architect, Trainer and Consultant with 10 years of experience in the industry. He is passionate about delivering value by creating software that is aligned with the business as well as by enabling teams to be successful & productive with Domain-Driven Design and other methodologies. Kacper worked with clients including Starbucks, Time Inc, GFT, Sportradar & Government agencies. In his spare time, he runs Domain-Driven Design London meetup.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      